import { memo, useEffect, useState } from 'react';
import AnimateTop from 'components/AnimateTop';

import {
  StepThanksContent,
  StepThanksConsider,
  StepThanksFree,
  ReturnHomeBtnWrapper,
} from './StepThanks.styled';
import { useSelector } from 'react-redux';
import { tagManager } from 'utils/tagManager';
import { useSearchParams } from 'react-router-dom';
import { HiOutlineCheck } from 'react-icons/hi';
import axios from 'axios';

const StepThanks = () => {
  const { sr_id, address, is_portal_link, areaStatus } = useSelector(
    (state) => state.form
  );
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries([...searchParams]);
  const [stripeFinalised, setStripeFinalised] = useState(false);
  const [sr, setSr] = useState(null);

  useEffect(() => {
    const sendStripeInfo = async () => {
    if (sr_id!="") {
      const sr = localStorage.getItem("sr_id");
      setSr(sr);
      const formData = new FormData();
      formData.append('srId', sr);
      formData.append('paymentIntent', localStorage.getItem('intent'));
      formData.append('paymentMethod', localStorage.getItem('payment'));
      formData.append('stripeCustomerId', localStorage.getItem('customerId'));
      const response = await axios.post(
        'https://hook.us1.make.com/ef4au98eokgxixb7z6dbugavosyev03s',
        formData
      );
      if (response) {
        setStripeFinalised(true);
      } 
    }
      
  };
    tagManager('purchase', {
      screen_name: 'formSubmitted',
      transaction_id: sr_id,
      value: address.full,
      currency: 'USD',
    });
    sendStripeInfo();
  }, [sr_id, address]);

  if(stripeFinalised){
    return (
      <AnimateTop>
        {areaStatus ? (
          <>
            <StepThanksContent>
              <h1>{`That's it! You've been great.`}</h1>
              <h2>Your Service Request is: #{sr}</h2>
              <h3>One of our representatives will contact you shortly.</h3>
              <h3>Thank you!</h3>
              <StepThanksConsider>
                <p>Please consider the following : </p>
                <p>
                  1. An email with all the details on this Service Request was
                  sent to the email address provided
                </p>
                <p>2. Keep your Service Request number as a reference</p>
                <p>
                  3. Feel free to use our Chatbot to get details and status of
                  your Service Request
                </p>
              </StepThanksConsider>
              <StepThanksFree>
                <p>Feel free to contact us if you have questions.</p>
                <p>phlebotomynetwork.com</p>
                <p>(415) 687-4854</p>
              </StepThanksFree>
              {!params.isPortal && (
                <ReturnHomeBtnWrapper>
                  <a href='/'>Return to Home</a>

                  <a href={is_portal_link}>Access to Portal</a>
                </ReturnHomeBtnWrapper>
              )}
            </StepThanksContent>
          </>
        ) : (
          <>
            <StepThanksContent>
              <h1>Perfect. We will notify you</h1>
              <h1 style={{ marginTop: '10px', marginBottom: '20px' }}>
                Thank You!
              </h1>
              <StepThanksFree>
                <p>Feel free to contact us if you have questions.</p>
                <p>phlebotomynetwork.com</p>
                <p>(415) 687-4854</p>
              </StepThanksFree>
              <ReturnHomeBtnWrapper>
                <a href='/'>
                  OK <HiOutlineCheck />
                </a>
              </ReturnHomeBtnWrapper>
            </StepThanksContent>
          </>
        )}
      </AnimateTop>
    );
  }
  return null;
};

export default memo(StepThanks);
